export default "__VITE_ASSET__C6W8bIP___"